export function DotSpinner() {
  return (
    <>
      <div className="flex items-center justify-center gap-2">
        <span className="dot dot-1 bg-accent-cyan h-2 w-2 rounded-full"></span>
        <span className="dot dot-2 bg-accent-cyan h-2 w-2 rounded-full"></span>
        <span className="dot dot-3 bg-accent-cyan h-2 w-2 rounded-full"></span>
      </div>

      <style>
        {`
          .dot {
            animation: dot-pulse 1.4s infinite ease-in-out;
          }
          .dot-1 {
            animation-delay: 0s;
          }
          .dot-2 {
            animation-delay: 0.2s;
          }
          .dot-3 {
            animation-delay: 0.4s;
          }
          @keyframes dot-pulse {
            0%, 80%, 100% {
              opacity: 0.4;
              transform: scale(1);
            }
            40% {
              opacity: 1;
              transform: scale(1.3);
            }
          }
        `}
      </style>
    </>
  )
}
